<ng-container *ngrxLet="showSpinner$ as showSpinner">

  @if (showSpinner) {
  <div class="content_loader">
    <div class="spinner-container">
      <pbb-spinner width="40%"></pbb-spinner>
    </div>
    <span> {{ 'COMMON.LOADING' | translate }}</span>
  </div>
  }

  <div class="full-content" [class.landing-bg]="isLandingPage">
    <router-outlet></router-outlet>
  </div>
  @if (!showSpinner && !hideFooter) {
  <footer role="contentinfo" [ngClass]="{'hideFooter': isCheckout, 'show-footer': isLandingPage }"
    [attr.aria-label]="'ARIA_LABEL.FOOTER' | translate">
    <pbb-footer id="footer"></pbb-footer>
  </footer>
  }
</ng-container>